"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["mfeAppName", "shouldUseShadowRoot"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { STATIC_MFE_URL, TENANT_NAME } from '@autoguru/global-configs';
import { Box } from '@autoguru/overdrive';
import { isBrowser } from '@autoguru/overdrive/dist/utils';
import { useMFEManifestFetch } from '../lib';
import { createDynamicMFEComponentClass } from './shadow-utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const StaticMFEShadowedComponent = _ref => {
  let {
      mfeAppName,
      shouldUseShadowRoot = true
    } = _ref,
    boxProps = _objectWithoutProperties(_ref, _excluded);
  const {
    manifest
  } = useMFEManifestFetch({
    mfeAppName,
    tenantName: TENANT_NAME,
    staticMFEUrl: STATIC_MFE_URL
  });
  if (!isBrowser) return null;

  // Define the custom element with a dynamic name
  if (!customElements.get(`${mfeAppName}-component`)) {
    const DynamicMFEComponent = createDynamicMFEComponentClass();
    customElements.define(`${mfeAppName}-component`, DynamicMFEComponent);
  }
  const MfeApp = `${mfeAppName}-component`;
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({}, boxProps), {}, {
    className: [`${(manifest === null || manifest === void 0 ? void 0 : manifest.mountDOMClass) || (manifest === null || manifest === void 0 ? void 0 : manifest.mountDOMId)}-wrap`, boxProps.className],
    children: manifest && /*#__PURE__*/_jsx(MfeApp, {
      "mfe-app-name": mfeAppName,
      manifest: JSON.stringify(manifest),
      "use-shadow-root": shouldUseShadowRoot ? 'true' : 'false'
    })
  }));
};
export default StaticMFEShadowedComponent;